<template>
  <div class="budget">
    <div class="container">
      <div class='cont'>
        <div class='info-box'>
          <div class='detail'>
            <div class='detail-item'>-业务信息</div>
            <div class='detail-span'>
              <span>工单号</span><span style='float: right; color: #777;'>{{orderNo}}</span>
            </div>
            <div v-if="userName != null && userName != ''" class='detail-span'>
              <span>用户名称</span><span style='float: right; color: #777;'>{{userName}}</span>
            </div>
            <div class='detail-span'>
              <span>业务状态</span><span style='float: right; color: #777;'>{{status}}</span>
            </div>
            <div class='detail-item'>-备注</div>
            <div class='detail-span'>
              <span>{{ remark }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-overlay :show="maskShow" z-index="1000">
      <div class="wrapper">
        <van-loading size="24px" vertical color="#FFF">数据处理中，请稍后...</van-loading>
      </div>
    </van-overlay>
    <div v-if="faceVisible" class="go-business button-primary" @click="goFace()">下一步</div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Notify, Grid, GridItem, Icon, Overlay, Loading, Image as VanImage } from 'vant'
import { getBusDetailReq, nextBusinessReq, getBizTokenReq } from '@/api/manage'

Vue.use(Notify)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(VanImage)
Vue.use(Icon)
Vue.use(Overlay)
Vue.use(Loading)

export default {
  data () {
    return {
      orderNo: '',
      userName: '',
      status: '',
      remark: '',
      maskShow: false,
      faceVisible: false
    }
  },
  components: {
  },
  created () {
    // 隐藏父路由底部logo
    this.$parent.footer(true)
    // 修改父路由头部文字
    const query = this.$route.query
    this.linkedId = query.linkedId

    // const reqRrl = '/client/api/single.do'
    const params = {
      token: this.$cookies.get('token'),
      openId: this.$cookies.get('openid'),
      linkedId: this.linkedId
    }
    getBusDetailReq(params).then(response => {
      const res = response.data
      console.log(res)
      if (res.code === 200) {
        this.$parent.changeBusstypeText(res.data.serviceName, '')
        this.orderNo = res.data.linkedId
        this.status = res.data.stepStatus
        if (res.data.stepName.indexOf('施工') > -1) {
          this.remark = '请等待工作人员到场施工'
        } else if (res.data.stepName.indexOf('归档') > -1) {
          this.remark = '业务已归档'
        } else if (res.data.stepName.indexOf('人脸识别') > -1) {
          this.remark = '请点击下一步进行人脸识别操作'
          this.faceVisible = true
        } else {
          this.remark = '请等待工作人员审核信息，审核完成后即可进行下一步操作'
        }

        // 人脸回调
        if (query.status) {
          this.maskShow = true
          const params = {
            token: this.$cookies.get('token'),
            openId: this.$cookies.get('openid'),
            currentModelId: res.data.modelId,
            linkedId: this.linkedId,
            data: '',
            type: -1
          }
          nextBusinessReq(params).then(response => {
            const res = response.data
            console.log(res)
            if (res.code === 200) {
              const localPage = res.data.localPage
              this.$router.push({
                path: localPage,
                query: {
                  token: this.$cookies.get('token'),
                  linkedId: res.data.linkedId
                }
              })
            }
          })
            .catch((res) => {
              Notify({ type: 'danger', message: '获取下一步业务失败' })
            })
        }
      }
    })
      .catch((res) => {
        Notify({ type: 'danger', message: '获取业务信息失败' })
      })
  },
  methods: {
    goFace () {
      const params = {
        token: this.$cookies.get('token'),
        linkedId: this.linkedId
      }
      getBizTokenReq(params).then(response => {
        const res = response.data
        if (res.code === 200) {
          const bizData = JSON.parse(res.data)
          console.log(bizData)
          window.location.href = bizData.Url
        }
      })
        .catch((res) => {
          Notify({ type: 'danger', message: '获取BizToken失败' })
        })
    }
  }
}
</script>
<style lang="less" scoped>
  .go-business {
    margin-left: 25px;
    width: calc(100% - 50px);
    display: inline-block;
    margin-top: 0px;
    text-align: center;
  }
  .button-primary {
    height: 48px;
    line-height: 48px;
    background-color: #008ACB;
    font-size: 16px;
    color: #fff;
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
  }
  .cont {
      position: relative;
      padding: 20px 15px 0;
  }
  .info-box {
      position: relative;
      margin-top: -60px;
      margin-left: 15px;
      margin-right: 15px;
      margin-bottom: 20px;
      padding: 5px 25px 35px;
      border-radius: 5px;
      box-shadow: 0px 0px 8px #999;
      background-color: #fff;
  }
  .info-box .row {
      display: flex;
      margin-top: 20px;
  }
  .detail {
      color: #333;
  }
  .detail-item {
    font-size: 16px;
    font-weight: bold;
    margin-top: 25px;
  }
  .detail-span {
    font-size: 15px;
    padding: 15px 0 10px 0;
    border-bottom: 1px solid #e6e6e6;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>
